import React from "react";
import BigNumber from "bignumber.js";
import "./BigNumberCard.scss"; // Adicione estilos personalizados para o card

const BigNumberCard = ({ valor, label, Icon }) => {
  const bigNumberValor = new BigNumber(valor).toFormat(2); // Formatação com 2 casas decimais

  return (
    <div className="big-number-card">
      <div className="big-number-content">
        {Icon && <Icon className="big-number-icon" />} {/* Renderiza o ícone, se fornecido */}
        <h2 className="big-number-value">{bigNumberValor}</h2>
        <p className="big-number-label">{label}</p>
      </div>
    </div>
  );
};

export default BigNumberCard;
